import { render, staticRenderFns } from "./costDetail.vue?vue&type=template&id=40303056&"
import script from "./costDetail.vue?vue&type=script&lang=js&"
export * from "./costDetail.vue?vue&type=script&lang=js&"
import style0 from "./costDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports